import {
  errorMetaData,
  pendingMetaData,
  successMetaData,
} from "@workspace/common";
import {
  CREATE_CANDIDATE_USER,
  CREATE_CANDIDATE_USER_FAILURE,
  CREATE_CANDIDATE_USER_SUCCESS,
  FETCH_CANDIDATE_BY_EMAIL,
  FETCH_CANDIDATE_BY_EMAIL_SUCCESS,
  FETCH_CANDIDATE_BY_EMAIL_FAILURE,
} from "./actionType";
import { error } from "@workspace/common/src/assets/images";

const initialState = {
  candidateUser: {},
  createCandidateUserMeta: {},
  candidateInfo: {},
  candidateInfoMeta: {},
};

const CandidateUserReducer = (state = initialState, action) => {
  switch (action.type) {
    // Create User
    case CREATE_CANDIDATE_USER:
      return {
        ...state,
        createCandidateUserMeta: pendingMetaData(),
      };
    case CREATE_CANDIDATE_USER_SUCCESS:
      return {
        createCandidateUserMeta: successMetaData(action.payload),
        candidateUser: action.payload,
      };
    case CREATE_CANDIDATE_USER_FAILURE:
      return {
        ...state,
        createCandidateUserMeta: errorMetaData(action.payload),
      };

    // Get Candidate By Email
    case FETCH_CANDIDATE_BY_EMAIL:
      return {
        ...state,
        candidateInfoMeta: pendingMetaData(),
      };
    case FETCH_CANDIDATE_BY_EMAIL_SUCCESS:
      return {
        ...state,
        candidateInfo: action.payload,
        candidateInfoMeta: successMetaData(action.payload),
      };
    case FETCH_CANDIDATE_BY_EMAIL_FAILURE:
      return {
        ...state,
        candidateInfo: errorMetaData(action.payload),
      };
    default:
      return state;
  }
};

export default CandidateUserReducer;
